document.addEventListener('DOMContentLoaded', () => {
  const colorSwatchBtn = document.querySelector('.color-swatch__btn');
  const colorSwatchContainer = document.querySelector('.popup-swatch-container');
  const colorSwatchBox = document.querySelector('.popup-swtach__box');
  const optionId = colorSwatchBtn.dataset.optionId;
  colorSwatchBtn.addEventListener('click', () => {
    colorSwatchContainer.classList.add('active');
  });
  colorSwatchContainer.addEventListener('click', () => {
    colorSwatchContainer.classList.remove('active');
  });
  colorSwatchBox.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  var swiper = new Swiper(".variant-swatch-thumbs", {
      slidesPerView: 10,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".variant-swatch-large", {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 10,
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        481: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
      thumbs: {
        swiper: swiper,
      },
      
    });
    swiper2.on("slideChange", function() {
      var activeSlide = swiper2.slides[swiper2.activeIndex];
      var optionName = activeSlide.getAttribute("data-item");
      var radioInput = document.querySelector(".variant-swatch-thumbs input[value='" + optionName + "']");
      radioInput.checked = true;
      triggerChangeEvent = !radioInput.checked && radioInput.value === optionName;
      radioInput.checked = radioInput.value === optionName;
      radioInput.dispatchEvent(new Event("change", { bubbles: true }));
      document.querySelector("[data-option-name]").textContent = optionName;
    }); 

 const chooseColorButton = document.querySelector('.popup-button__selection');
  chooseColorButton.addEventListener('click', function() {
    const selectedOptionValue = document.querySelector('.variant-swatch-thumbs .swiper-slide-thumb-active').dataset.item;
    colorSwatchBtn.textContent = selectedOptionValue;
    colorSwatchContainer.classList.remove('active');
  });

  const moreInfoWrapper = document.querySelectorAll('.more-info__wrapper');
  moreInfoWrapper.forEach(wrapper => {
    const moreInfoBtn = wrapper.querySelector('.product-more__info-btn');
    const moreInfoContent = wrapper.querySelector('.more-info__popup');
    const moreInfoCloseBtn = wrapper.querySelector('.more-info__popup-close');
    moreInfoBtn.addEventListener('click', () => {
      moreInfoContent.classList.add('active');
    });
    moreInfoCloseBtn.addEventListener('click', () => {
      moreInfoContent.classList.remove('active');
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    const checkoutButton = document.querySelector('.checkout-button');
    if (checkoutButton) {
        checkoutButton.addEventListener('click', (event) => {
            event.preventDefault(); // Prevent default action
            const urlParams = new URLSearchParams(window.location.search);
            const discountCode = urlParams.get('Free10');
            if (discountCode) {
                // Save the discount code as a session cookie
                document.cookie = `discount_code=${discountCode}; path=/`;
                // Send GET request to "/discount/[discountcode]"
                fetch(`/discount/${discountCode}`)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Failed to apply discount');
                        }
                        // Optionally, trigger a cart refresh event
                        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                            bubbles: true,
                            detail: {
                                openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
                            }
                        }));
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        // Handle error, e.g., display an error message to the user
                    });
            }
        });
    }
});


  // document.addEventListener('variant:added',  function (event) {
  //   // FREE GIFT SCRIPT STARTS
  //   let freeGiftParentIDs = localStorage.getItem("freeGiftParentIDs");
  //   let freeGiftId = localStorage.getItem("freeGiftId");
  //   let giftItemAvailableInCart = localStorage.getItem("giftItemAvailableInCart")
  //   if (!giftItemAvailableInCart && freeGiftParentIDs?.length && freeGiftId) {
  //     console.log({freeGiftParentIDs, freeGiftId})
    
  //     fetch(window.Shopify.routes.root + 'cart/add.js', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify({
  //         'items': [{
  //           'id': freeGiftId,
  //           'quantity': 3
  //         }]
  //       })
  //     })
  //     .then(response => {
  //       return response.json();
  //     })
  //     .then(response => {
  //       console.log({response})
  //       localStorage.setItem("giftItemAvailableInCart", true)
  //     })
  //     .catch((error) => {
  //       console.error('Error:', error);
  //     });
        
  //   }
  //   // FREE GIFT SCRIPT ENDS
  // });
  document.addEventListener('cart:updated', function(event) {
    localStorage.removeItem("giftItemAvailableInCart");
    // var cart = event.detail.cart;
    // // FREE GIFT SCRIPT STARTS
    // let freeGiftParentIDs = localStorage.getItem("freeGiftParentIDs");
    // let freeGiftId = localStorage.getItem("freeGiftId");
    // if (freeGiftParentIDs) {
    //   let lineItem = document.querySelector('#mini-cart-form').querySelectorAll(".line-item");
    //   let deletedId = lineItem.dataset.variantId;
    //   console.log("free gift ids",freeGiftParentIDs,"deleted id", deletedId);
      
    //   const REMOVE_GIFT_ITEM = freeGiftParentIDs.includes(deletedId) && quantity == 0;
    //   console.log({includes: freeGiftParentIDs.includes(deletedId), REMOVE_GIFT_ITEM})
      
    //   if (REMOVE_GIFT_ITEM) {
    //     try {
    //       let res = fetch(window.Shopify.routes.root + 'cart/update.js', {
    //         method: 'POST',
    //         headers: {
    //           'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify({
    //           updates: {
    //             [freeGiftId]: 0,
    //             [deletedId]: 0
    //           }
    //         })
    //       })
    //       localStorage.removeItem("giftItemAvailableInCart")
    //       let response = res.json()
    //       console.log({response})
    //       // window.location.reload()
    //     } catch (error) {
    //       console.log({error})
    //     }
    //   }
    // }
    // FREE GIFT SCRIPT ENDS
   });

});